import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import ProductCard from "../components/ProductCard";
import { CATEGORIES, PRODUCTS } from "../data/products";

export default function ShopAll() {
  const { category } = useParams();
  const nav = useNavigate();
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (category && !CATEGORIES.find((c) => c.id === category) && category !== "all") {
      nav("/shop", { replace: true });
    }
  }, [category, nav]);

  const currentCat = category || "all";
  const filtered = useMemo(() => {
    let list = currentCat === "all" ? PRODUCTS : PRODUCTS.filter((p) => p.category === currentCat);
    const q = query.trim().toLowerCase();
    if (q) list = list.filter((p) => p.name.toLowerCase().includes(q) || p.description.toLowerCase().includes(q));
    return list;
  }, [currentCat, query]);

  const catLabel = CATEGORIES.find((c) => c.id === currentCat)?.label || "Shop All";

  return (
    <section className="shop-page">
      <header className="shop-page-head">
        <p className="chapter-tag"><em>Shop</em> · {filtered.length} product{filtered.length === 1 ? "" : "s"}</p>
        <h1 className="shop-h1" data-testid="shop-heading">{currentCat === "all" ? "Shop All Products" : catLabel}</h1>
        <p className="shop-sub">Explore our natural range — Moringa Powder, dehydrated fruits, dehydrated vegetables, natural powders and Moringa sweets.</p>

        <div className="shop-search">
          <Search size={16} />
          <input type="search" placeholder="Search products…" value={query} onChange={(e) => setQuery(e.target.value)}
            data-testid="shop-search-input" aria-label="Search products" />
          {query && <button onClick={() => setQuery("")} data-testid="shop-search-clear" aria-label="Clear search"><X size={14} /></button>}
        </div>

        <nav className="shop-filters" aria-label="Category filters">
          <Link to="/shop" className={currentCat === "all" ? "chip is-active" : "chip"} data-testid="filter-all">All</Link>
          {CATEGORIES.map((c) => (
            <Link key={c.id} to={`/shop/${c.id}`} className={currentCat === c.id ? "chip is-active" : "chip"} data-testid={`filter-${c.id}`}>
              {c.label}
            </Link>
          ))}
        </nav>
      </header>

      {filtered.length === 0 ? (
        <div className="shop-empty" data-testid="shop-empty">
          <p>No products found. Try a different search.</p>
        </div>
      ) : (
        <div className="product-grid product-grid-wide">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </section>
  );
}
